import { c as _c } from "react/compiler-runtime";
import type { RuleExpression } from '@onefootprint/request-types/dashboard';
import React from 'react';
import { useTranslation } from 'react-i18next';
import RuleChip from './components/rule-chip';
export type RuleRowProps = {
  ruleExpression: RuleExpression;
};
const RuleRow = t0 => {
  const $ = _c(13);
  const {
    ruleExpression
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.rules.ruleRow"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <span className="text-body-2">{t2}</span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== ruleExpression || $[6] !== t) {
    let t5;
    if ($[8] !== t) {
      t5 = (expression, index) => <React.Fragment key={`${expression.field}-${expression.op}-${expression.value}`}>{index > 0 && <span className="text-body-2 px-1">{t(_temp2)}</span>}<RuleChip ruleExpression={expression} /></React.Fragment>;
      $[8] = t;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    t4 = ruleExpression.map(t5);
    $[5] = ruleExpression;
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <li className="flex items-center gap-2 flex-wrap pb-2">{t3}{t4}</li>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default RuleRow;
function _temp($) {
  return $.if;
}
function _temp2($_0) {
  return $_0.and;
}